// components/DayWiseTimeSlots.js
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
// import Checkbox from './CustomCheckbox';
import Checkbox from '../../../../components/CustomCheckbox'
import CustomTextField from '../../../../components/CustomTextField';
import moment from 'moment';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


const DayWiseTimeSlots = ({
  values,
  onDaySelect,
  onSlotChange,
  onAddSlot,
  onRemoveSlot,
  isEditable = true
}) => {
  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="flex-start" gap={2} mb={1}>
  <Box width="20%">
    <Typography color="primary" fontWeight="bold">Day</Typography>
  </Box>
  <Box width="35%">
    <Typography color="primary" fontWeight="bold">Start time</Typography>
  </Box>
  <Box width="35%">
    <Typography color="primary" fontWeight="bold">End time</Typography>
  </Box>
</Box>

      {values?.map((pd, i) => (
        <Grid item xs={12} key={pd.day + i}>
          <div className="flex-row mt10">
            <div className="w10Per">
              <Checkbox
                checked={pd.isSelected}
                onChange={() => onDaySelect(i, !pd.isSelected)}
                disabled={!isEditable}
              />
            </div>
            <div className="w30Per mt10">
              <Typography className="fs14">{pd.day}</Typography>
            </div>
            <div className="flex-column">
              {pd.slots?.map((slot, j) => (
                <div className="flex-row-ali-cen mv5" key={j}>
                  <div className="w40Per pr10">
                    <CustomTextField
                    type="time"
                      name="startTime"
                      value={slot.startTime || '08:00'}
                      handleChange={(e) =>
                        onSlotChange('startTime', e.target.value, i, j)
                      }
                      mobileTime
                      fullWidth
                      is12HourFomat={false}
                      disabled={!isEditable}
                    />
                  </div>
                  <div className="w40Per pr10">
                    <CustomTextField
                    type="time"
                      name="endTime"
                      value={slot.endTime || '20:00'}
                      handleChange={(e) =>
                        onSlotChange('endTime', e.target.value, i, j)
                      }
                      mobileTime
                      fullWidth
                      is12HourFomat={false}
                      disabled={!isEditable}
                    />
                  </div>
                  <div className="w10Per">
                    <div className="flex-row">
                      {pd.slots.length > 1 && isEditable && (
                        <RemoveIcon
                          onClick={() => onRemoveSlot(i, j)}
                          style={{ cursor: 'pointer' }}
                        />
                      )}
                      {j === 0 && isEditable && (
                        <AddIcon
                          onClick={() => onAddSlot(i)}
                          style={{ cursor: 'pointer', marginLeft: 8 }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Grid>
      ))}
    </>
  );
};

export default DayWiseTimeSlots;
